let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("aHG2I"), load("bJvam"), load("cuD1H")]).then(() => parcelRequire('b5seU'));